import { Result } from "@/services/backend/htz/inspection/components/inspection-result";
import { UUID } from "@bitory-gmbh/nidavellir";

export interface VisualAssessmentCatalog {
  id: string;
  name: string;
  companyId: UUID;
  items: Item[];
}

export function addItem(
  catalog: VisualAssessmentCatalog,
  item: Item,
): VisualAssessmentCatalog {
  return {
    ...catalog,
    items: [...catalog.items, item],
  };
}

export function updateItem(
  catalog: VisualAssessmentCatalog,
  item: Item,
): VisualAssessmentCatalog {
  return {
    ...catalog,
    items: catalog.items.map((i) => {
      if (i.id === item.id) {
        return item;
      }
      return i;
    }),
  };
}

export function deleteItem(
  catalog: VisualAssessmentCatalog,
  itemId: string,
): VisualAssessmentCatalog {
  return {
    ...catalog,
    items: catalog.items.filter((item) => item.id !== itemId),
  };
}

export function itemsForComponentKind(
  catalog: VisualAssessmentCatalog,
  componentKindId: string,
): Item[] {
  return [
    ...catalog.items.filter((item) =>
      item.componentKinds.some((ck) => ck === componentKindId),
    ),
  ];
}

export interface Item {
  id: string;
  catalogId: string;
  componentKinds: string[];
  deficiency: string;
  recommendation: string;
  result: Result;
}

export function newItem(id: string, catalogId: string): Item {
  return {
    id,
    catalogId,
    componentKinds: [],
    deficiency: "",
    recommendation: "",
    result: Result.ZERO,
  };
}
